import type { AdminOverview, BotCommand, BotSlot, BotStatus, UserProfile } from '../domain/types';

export const mockUser: UserProfile = {
  id: 'user_mock',
  email: 'whiteoutv01001@gmail.com',
  role: 'user'
};

export const mockAdmin: UserProfile = {
  id: 'admin_mock',
  email: 'whitebot.admin@gmail.com',
  role: 'admin'
};

export const mockSlots: BotSlot[] = [
  {
    id: 'slot_3',
    slotKey: 'slot_3',
    label: 'Hosted Test',
    userEmail: mockUser.email,
    agentId: 'local-dev',
    licenseStatus: 'active',
    licensePlan: 'pro',
    planKey: 'pro',
    linked: true,
    state: 'ready_world',
    enabledModules: { collect: true, train_troops: true, auto_hunt: true, intelligence: true }
  }
];

export const mockStatus: BotStatus = {
  slotId: 'slot_3',
  state: 'ready_world',
  running: false,
  bridgeStatus: 'online',
  agentLastSeenAt: new Date().toISOString(),
  localAvailable: true,
  provisioning: { status: 'ready', label: 'listo', detail: 'wb_003' },
  lastResult: 'ok',
  nextCheckSeconds: 572,
  latestLogLine: 'Ready. Waiting for next command.',
  runtimeSeconds: 3862,
  screenshotUrl: null,
  colonyQueues: [
    { queue: 1, action: 'training', remaining: '03:24:51' },
    { queue: 2, action: 'training', remaining: '03:24:58' },
    { queue: 3, action: 'training', remaining: '03:25:05' }
  ],
  worldQueues: [
    { queue: 1, action: 'gathering', remaining: '01:39:31' },
    { queue: 2, action: 'gathering', remaining: '01:35:33' },
    { queue: 3, action: 'gathering', remaining: '01:35:36' },
    { queue: 4, action: 'gathering', remaining: '01:32:56' }
  ]
};

export const mockCommands: BotCommand[] = [];

export const mockAdminOverview: AdminOverview = {
  users: [mockAdmin, mockUser],
  slots: mockSlots,
  agentHosts: [
    {
      agentId: 'local-dev',
      label: 'local-dev',
      status: 'online',
      lastSeenAt: new Date().toISOString(),
      inventoryUpdatedAt: new Date().toISOString(),
      inventory: {
        summary: { ready_profiles: 1, warning_profiles: 0, error_profiles: 0 },
        profiles: [
          {
            profile: 'wb_003',
            instance_name: 'WB-003',
            instance_key: 'Pie64_3',
            device_id: '127.0.0.1:5585',
            adb_port: 5585,
            detected: true,
            assigned_slots: ['slot_3'],
            warnings: [],
            health: 'ready',
            recommendation: 'Profile is ready for slot operation'
          }
        ],
        provisioning_actions: []
      }
    }
  ],
  auditEvents: [
    {
      id: 'audit_1',
      createdAt: new Date(Date.now() - 90_000).toISOString(),
      eventType: 'slot_reserved',
      userId: 'user-1',
      slotId: 'slot-3-id',
      agentId: 'local-dev',
      payload: { slot_key: 'slot_3' }
    }
  ]
};
